<template>
    <div>
        <el-row :gutter="20" class="mgb20">
            <el-col :span="6">
                <el-card shadow="hover" :body-style="{padding: '0px', }">
                    <div class="grid-content grid-con-1">
                        <i class="fa fa-user-circle grid-con-icon"></i>
                        <div class="grid-cont-right">
                            <div class="grid-num">{{countData.userCount}}</div>
                            <div>用户总量</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" :body-style="{padding: '0px'}">
                    <div class="grid-content grid-con-1">
                        <i class="fa fa-sign-in grid-con-icon"></i>
                        <div class="grid-cont-right">
                            <div class="grid-num">{{countData.loginSuccessCount}}</div>
                            <div>用户访问量</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" :body-style="{padding: '0px'}">
                    <div class="grid-content grid-con-1">
                        <i class="fa fa-reorder grid-con-icon"></i>
                        <div class="grid-cont-right">
                            <div class="grid-num">{{countData.examRecordCount}}</div>
                            <div>总考试次数</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" :body-style="{padding: '0px'}">
                    <div class="grid-content grid-con-1">
                        <i class="fa fa-line-chart grid-con-icon"></i>
                        <div class="grid-cont-right">
                            <div class="grid-num">{{countData.userNewCount}}</div>
                            <div>今日新增人数</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12" v-for="(item, index) in scoreData" :key="index">
                <div class="score-grid-content">
                    <score-data v-bind="item"></score-data>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    // import HighCharts from  '../HighCharts.vue';
    import ScoreData from '../ScoreData.vue';
    export default {
        name: 'dashboard',
        components: {
            // HighCharts,
            ScoreData
        },
        data: function() {
            return {
                countData:{
                    userCount:0,
                    loginSuccessCount:0,
                    examRecordCount:0,
                    userNewCount:0
                },
                scoreData:[]
            }
        },
        computed: {
            username() {
                return this.$store.state.userInfo.chName;
            },
            role() {
                return this.name === 'admin' ? '超级管理员' : '普通用户';
            }
        },
        created() {
            this.getCountData();
            this.getScoreData();
        },
        methods:{
            async getCountData() {
                let res = await this.$axios.get('/manage/home/countData');
                if (res.code == 200) {
                    this.countData = res.data;
                }
            },
            async getScoreData() {
                let res = await this.$axios.get('/manage/home/scoreData');
                if (res.code == 200) {
                    this.scoreData = res.data;
                }
            }
        }
    }

</script>


<style scoped>
    .el-row {
        margin-bottom: 20px;
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 100px;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 12px;
        color: #999;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
    }

    .grid-con-icon {
        font-size: 50px;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        color: #fff;
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(45, 140, 240);
    }

    .grid-con-1 .grid-num {
        color: rgb(45, 140, 240);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(100, 213, 114);
    }

    .grid-con-2 .grid-num {
        color: rgb(45, 140, 240);
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(242, 94, 67);
    }

    .grid-con-3 .grid-num {
        color: rgb(242, 94, 67);
    }

    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    }

    .user-avator {
        width: 120px;
        height: 120px;
        border-radius: 50%;
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }

    .user-info-list {
        font-size: 14px;
        color: #999;
        line-height: 25px;
    }

    .user-info-list span {
        margin-left: 70px;
    }

    .mgb20 {
        margin-bottom: 10px;
    }

    .todo-item {
        font-size: 14px;
    }

    .todo-item-del {
        text-decoration: line-through;
        color: #999;
    }

  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .score-grid-content {
    border-radius: 4px;
    min-height: 36px;
    margin:10px 0;
    background-color: white;
    padding: 20px;
    /* width: 600px; */
  }

</style>
